import { SegmentedMessage } from 'sms-segments-calculator';

export function getSmsSegmentCount(plainText: string): number {
  if (!plainText.trim()) {
    return 0;
  }
  const message = new SegmentedMessage(plainText);
  return message.segmentsCount;
}
